var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-3 mb-5",attrs:{"outlined":""}},[_c('div',[_c('strong',[_vm._v("Usia Relawan")])]),_c('v-divider',{staticClass:"my-2"}),_c('Cusia')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }